module.exports = "/complete_verification-1afbb512cf0392b8e3429640c0388809.svg";